export const DEFAULT_ASSISTANT_MESSAGE = {
  content: '**Welcome to Numerator Narratives.**\n\nAsk a business question to get started.',
  id: 'assistant-welcome',
  role: 'assistant',
};
